import Vue from "vue"

export default Vue.extend({
  template: `
    <div style="display: flex">
      <vs-button
        v-if="$can('update', 'whatsapp')"
        radius
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-edit"
        @click="setEditWhatsapp"
      ></vs-button>
      <vs-button
        v-if="$can('delete', 'whatsapp')"
        radius
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-trash-2"
        @click="setDeleteSms"
      ></vs-button>
    </div>
    `,
  data() {
    return {
      value: null
    }
  },
  methods: {
    setEditWhatsapp () {
      if (this.params.data.id == null) {
        this.$vs.notify({
          text: this.$t("whatsapp.nonEditableStatus"),
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-circle"
        })
      } else this.$store.dispatch('whatsapp/set_whatsapp', this.params.data)
    },
    setDeleteSms () {
      this.$store.dispatch('whatsapp/set_delete_whatsapp', this.params.data)
    }
  }
})
